import { NgModule } from '@angular/core';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {MessageModule} from 'primeng/message';
import {MessageService} from 'primeng/api';
import {ReactiveFormsModule} from '@angular/forms';
import {ToastModule} from 'primeng/toast';

import {AcabimCommonModule} from '@cas-hub/acabim-common-client';
import {AcabimFinancialLibModule} from '@cas-hub/acabim-financial-client';

import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { OnboardingStepWrapperComponent } from './_components/onboarding-step-wrapper/onboarding-step-wrapper.component';
import { OnboardingFinancialEnableComponent } from './_components/onboarding-financial-enable/onboarding-financial-enable.component';
import { OnboardingActionsAutoExecuteComponent } from './_components/onboarding-actions-auto-execute/onboarding-actions-auto-execute.component';
import { OnboardingBuildingAssetsAutoGenerateComponent } from './_components/onboarding-building-assets-auto-generate/onboarding-building-assets-auto-generate.component';
import { OnboardingLtmItemsAutoGenerateComponent } from './_components/onboarding-ltm-items-auto-generate/onboarding-ltm-items-auto-generate.component';
import { OnboardingFinancialDatesComponent } from './_components/onboarding-financial-dates/onboarding-financial-dates.component';
import { OnboardingFinancialCurrencyTaxComponent } from './_components/onboarding-financial-currency-tax/onboarding-financial-currency-tax.component';
import { OnboardingFinancialMaintenanceComponent } from './_components/onboarding-financial-maintenance/onboarding-financial-maintenance.component';
import { OnboardingBrandingComponent } from './_components/onboarding-branding/onboarding-branding.component';



@NgModule({
  declarations: [
    OnboardingComponent,
    OnboardingStepWrapperComponent,
    OnboardingFinancialEnableComponent,
    OnboardingActionsAutoExecuteComponent,
    OnboardingBuildingAssetsAutoGenerateComponent,
    OnboardingLtmItemsAutoGenerateComponent,
    OnboardingFinancialDatesComponent,
    OnboardingFinancialCurrencyTaxComponent,
    OnboardingFinancialMaintenanceComponent,
    OnboardingBrandingComponent
  ],
  imports: [
    AcabimCommonModule,
    AcabimFinancialLibModule,
    CalendarModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    MessageModule,
    ReactiveFormsModule,
    ToastModule
  ],
  exports: [
    OnboardingComponent
  ],
  providers: [MessageService],
})
export class OnboardingModule { }
